export const colors = {
  bg: '#F5F5F5',
  darkGrey: '#333333',
  grey: '#6b6b6b',
  lgGrey: '#767676',
  lgGrey2: '#e4e4e4',
  lgRed: '#A50034',
  lgTag: '#B04D16',
  lgSuccess: '#4A8316'
} as const
